/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_No_EmailInputs */

const en_auth_error_no_email = /** @type {(inputs: Auth_Error_No_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your provider didn't share an email address with us, so we can't create your account. Signing up with an email address works instead.`)
};

const es_auth_error_no_email = /** @type {(inputs: Auth_Error_No_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu proveedor no compartió una dirección de correo con nosotros, así que no podemos crear tu cuenta. Registrarte con un correo electrónico sí funciona.`)
};

/**
* | output |
* | --- |
* | "Your provider didn't share an email address with us, so we can't create your account. Signing up with an email address works instead." |
*
* @param {Auth_Error_No_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_error_no_email = /** @type {((inputs?: Auth_Error_No_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_No_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_error_no_email(inputs)
	return en_auth_error_no_email(inputs)
});